// Gates on the payment step's Pay button that the Stripe card form must not
// override. The card form stays mounted while another payment option hides
// it, and it can report itself complete with no tap (a saved card filled in
// on mount), so its change event alone is not permission to enable Pay.

// The card form's "complete" change event may enable Pay only while the Card
// option is the one selected. Under any other option the card form is hidden
// and completing it means nothing.
export function cardFormCompleteEnablesSubmit(selectedOptionName) {
  return selectedOptionName === 'Card'
}

// A gift card that leaves a balance has to be paid by card. The Gift card
// option never runs the card charge, so a submit under it would book the
// slot with the balance unpaid and the booking would be released minutes
// later. No-capture checkouts (pay on arrival, requests charged on approval)
// owe nothing now and are exempt.
export function giftCardBalanceBlocksSubmit({ selectedOptionName, dueNow, noCaptureCheckout }) {
  if (noCaptureCheckout) return false
  if (selectedOptionName !== 'Gift card') return false
  return Number(dueNow) > 0
}
